<template lang="pug">
span
  span(@click="modal_open")
    slot(name="activator")
  v-dialog.d-inline(v-model="isModalVisible" persistent max-width="480")
    v-card
      title-bar(dark) {{ this.title }}
      v-card-text
        v-layout
          v-flex.xs12.columns
            div
              v-text-field(
                v-model="filter"
                append-icon="search"
                placeholder="Search static lists"
              )
            v-list
              v-list-tile(v-for="list in filteredEmailLists" :key="list.id")
                v-list-tile-action
                  v-checkbox.mt-3(
                    v-model="listIds"
                    :value="list.id"
                    @change="changeSelectedEmailLists"
                  )
                v-list-tile-content.clickable-column(@click="clickChangeSelectedEmailLists(list.id)")
                  v-list-tile-title {{list.list_name}}
                    v-icon.facebook-logo(v-if="list.fb_user_type_id" color="primary" right) {{ getIcon(list.fb_user_type_id) }}
        span
          v-icon.mr-2 info
          | Your contact will also be removed from any custom audiences synced with the selected static list(s).
      v-card-actions
        v-spacer
        v-btn(flat @click="cancel") Cancel
        v-btn.primary(@click="removeContactFromLists") Save
</template>
<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import TitleBar from '@/Core/components/TitleBar';
import Modal from '@/Core/mixins/modal';

export default {
  components: {
    TitleBar,
  },
  mixins: [Modal],
  props: {
    emailLists: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      filter: '',
      listIds: [],
      selectedEmailLists: [],
    };
  },
  mounted() {
    this.listIds = this.emailLists.map(l => l.id);
  },
  computed: {
    ...mapState({
      contact: state => state.contact.contact,
    }),
    filteredEmailLists() {
      return this.emailLists.filter(list => {
        if (this.filter && list.list_name) {
          return list.list_name.toLowerCase().match(this.filter.toLowerCase());
        }
        return list;
      });
    },
    title() {
      if (this.emailLists.length === 1) {
        return 'Add contact to static list';
      }
      return 'Remove Contact From Static Lists';
    },
  },
  watch: {
    emailLists() {
      this.listIds = this.emailLists.map(l => l.id);
    },
  },
  methods: {
    ...mapActions('contact', [
      'removeContactFromEmailList',
      'findEmailListsByContact',
      'assignRemovedFromStaticListsHistory',
    ]),
    ...mapActions('bulkActions', ['addContactsToStaticList']),
    ...mapMutations('contact', ['setRemovedFromStaticLists']),
    clickChangeSelectedEmailLists(id) {
      const index = this.listIds.indexOf(id);
      if (index > -1) {
        this.listIds.splice(index, 1);
      } else {
        this.listIds.push(id);
      }
      this.changeSelectedEmailLists();
    },
    changeSelectedEmailLists() {
      this.selectedEmailLists = this.emailLists.filter(list => {
        return !this.listIds.includes(list.id);
      });
    },
    async removeContactFromLists() {
      const removedContacts = Object.keys(this.selectedEmailLists).map(async list => {
        return this.removeContactFromEmailList({
          listId: this.selectedEmailLists[list].id,
          idContact: this.contact.id,
        });
      });
      Promise.all(removedContacts).then(() => {
        this.$emit('updateEmailListsState');
        this.listIds = [];
        this.assignRemovedFromStaticListsHistory(this.selectedEmailLists);
        this.selectedEmailLists = [];
        this.setRemovedFromStaticLists(true);
        this.filter = '';
        this.modal_close();
      });
    },
    cancel() {
      this.modal_close();
      this.selectedEmailLists = [];
      this.filter = '';
      this.listIds = this.emailLists.map(l => l.id);
    },
    getIcon(fbUserTypeId) {
      const icon = fbUserTypeId === 'Personal' ? '$vuetify.icons.facebook' : '$vuetify.icons.liondesk';
      return icon;
    },
  },
};
</script>
<style scoped lang="scss">
.v-dialog {
  overflow: hidden;

  h3,
  h5 {
    color: #999;
    text-transform: uppercase;
  }

  & > .v-card {
    & > .v-card__text {
      display: flex;
      overflow: hidden;
      flex-direction: column;

      .wrapper {
        padding: 0;
        flex: 1 1;
      }
      .layout {
        max-height: 370px;
        padding: 0;
      }
      .flex {
        padding: 0 1em;
      }
    }
  }
}

.columns {
  display: flex;
  overflow: hidden;
  flex-direction: column;
  border-right: 1px solid #eee;

  .v-input {
    flex: 1 1 15%;
  }

  .v-list {
    overflow: auto;
    max-width: 100%;
    .v-list__tile {
      padding: 0;
      cursor: pointer;

      .v-list__tile__action {
        min-width: 32px;
      }
    }
  }
}
.clickable-column {
  cursor: pointer;
}
</style>
